import { FC } from 'react';
import UploadFile, { UploadFileProps } from './uploadFile';
import UploadImage, { UploadImageProps } from './uploadImage';
import UploadImages, { UploadImagesProps } from './uploadImages';
import './style.less';

export type ISuperUploadComponent = FC<UploadImageProps> & {
  Image: FC<UploadImageProps>;
  Images: FC<UploadImagesProps>;
  File: FC<UploadFileProps>;
};

/** 上传 */
const SuperUpload = UploadImage as ISuperUploadComponent;
SuperUpload.Image = UploadImage;
SuperUpload.Images = UploadImages;
SuperUpload.File = UploadFile;

export default SuperUpload;
